export const MAIN = "/";
export const ABOUT = "/about";
export const COLLABORATION_PAGE = "/collaboration";
export const COLLABORATION_REQUEST_PAGE = "/collaboration/request";
export const COURSES = "/courses";
export const COURSE = "/courses/:id";
export const REQUEST_PAGE = "/courses/:id/request";
export const GAME_ROUTER = "/home/game/*";
export const LOGIN = "/login";
export const RECOVERY_PASSWORD = "/recoveryPassword/:id/:uuid";
export const TEACHERS = "/teachers";
export const TEACHER_PAGE = "/teachers/:id";
export const NOT_FOUND = "*";
// TEACHER
export const GROUP_PAGE = "/home/group/:id";
export const ADD_STUDENT_PAGE = "/home/group/:id/addStudent";
export const HOME_EDITOR_PAGE = "/home/group/:id/homework";
export const HOME_EDITOR_PAGE_BY_STUDENT = "/home/group/:id/homework/:userId";
export const PAY_PAGE = "/home/pay";
export const SCHEDULE_TEACHER_PAGE = "/home/schedule";
// STUDENT
export const BALANCE_PAGE = "/home/balance";
export const HOMEWORK_STUDENT_PAGE = "/home/homework";
export const STUDENT_COMMON_HOMEWORK_EDITOR_PAGE = "/home/homework/:hwId/setting";
// ADMIN
export const REQUEST_ADMIN_PAGE = "/home/requests/course";
export const COLLABORATION_REQUEST_ADMIN_PAGE = "/home/requests/collaboration";
export const STATISTIC_PAGE = "/home/statistic";
export const UNIQUE_HOSTS_CHART = "/home/statistic/uniqueHosts";
export const UNIQUE_VISITOR_CHART = "/home/statistic/uniqueVisitors";
export const STUDENT_ADMIN_PAGE = "/home/student";
export const TEACHER_ADMIN_PAGE = "/home/teacher";
export const ADD_TEACHER_PAGE = "/home/teacher/add";
// COMMON
export const HOME = "/home";
export const PERSONAL_SETTINGS = "/home/settings";
export const TRAINERS_PAGE = "/home/trainers";
export const ABACUS_PAGE = "/home/trainers/abacus";
export const MENTAL_TRAINING_PAGE = "/home/trainers/mental";
export const COMMON_HOMEWORK_EDITOR_PAGE = "/home/trainers/mental/setting";
export const GAME = "/game";
